import React from 'react';
// template components
import Accordion from '@nmx/template/dist/componentLibrary/modules/Accordion';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import MinusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/MinusSignFill';
import PlusSignFillIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/PlusSignFill';

export default () => (
  <SectionContainer
    id='life-insurance-faq' // '-section-container' will be appended dynamically
    moduleName='faq-module'
    moduleVariation='A'>
    <Row align='center'>
      <Col
        align='center'
        medium={8}
        large={6}>
        <Typography
          component='h2'
          nextElement='typography'>
          Questions about life insurance&#63; <WidowBlock>We&#39;ve got answers.</WidowBlock>
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Accordion
          id='faq-life-insurance'
          variant='secondary'
          toggleOpenIcon={PlusSignFillIcon}
          toggleCloseIcon={MinusSignFillIcon}
          isFAQ
          items={[
            {
              id: 'life-insurance-quote-faq',
              title:<>How do I get a life <WidowBlock>insurance quote&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Your advisor will ask you deeper questions to find out which type of life insurance is right for you and get you an accurate quote. They&#39;ll also help you figure out how much you might need to keep your loved ones financially sound if the unexpected happens to you.{' '}
                    <Link
                      id='life-insurance-how-to-get-life-insurance-talk-to-advisor-link-faq'
                      variant='primaryDeemphasize'
                      linkUrl='/find-a-financial-advisor/'>
                      Find your advisor and talk about your needs
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-how-does-term-work-faq',
              title: <>How does term life <WidowBlock>insurance work&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    It&#39;s simple. <Link
                      id='life-insurance-how-term-life-insurance-works-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/term-life-insurance/'>
                      Term life
                    </Link>
                    {' '}is an affordable way to have the protection you want for a set amount of time. With the help of your advisor, you&#39;ll determine the right amount of coverage your loved ones will need. Then, you&#39;ll figure out how long you need coverage for and choose from the available periods. Typically, 10, 15, 20 years, or even to a certain age. Keep in mind, once that time is up your coverage will end. Looking for coverage that&#39;s more permanent&#63; Our{' '}
                    <Link
                      id='life-insurance-whole-life-insurance-how-term-life-works-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      ariaLabel='Learn more about whole life insurance'>
                      whole life insurance
                    </Link>
                    {' '}lasts your entire life and has other benefits that you can use along the way.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-different-types-of-life-insurance-faq',
              title: <>What are the different types of <WidowBlock>life insurance&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    You can protect your loved ones with four types of life insurance:{' '}
                    <Link
                      id='life-insurance-term-life-insurance-that-can-give-protection-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/term-life-insurance/'>
                      term life insurance
                    </Link>
                    ,{' '}
                    <Link
                      id='life-insurance-whole-life-insurance-that-can-give-protection-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/whole-life-insurance/'>
                      whole life insurance
                    </Link>
                    ,{' '}
                    <Link
                      id='life-insurance-universal-life-insurance-that-can-give-protection-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/universal-life-insurance/'>
                      universal life insurance
                    </Link>
                    , and{' '}
                    <Link
                      id='life-insurance-vul-insurance-that-can-give-protection-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/variable-universal-life-insurance-vul/'>
                      variable universal life insurance
                    </Link>. Term life only covers you for a specified amount of time. Whole, universal, and variable universal all have lifelong coverage. And with the whole, universal, and variable universal, your policy will accumulate cash value over time.<sup>3</sup> You can use the cash value for anything you need throughout your life. And you can earn dividends<sup>6</sup> with whole life that can be taken as cash, used to pay premiums, or buy more coverage. Not sure which kind of life insurance is best for you&#63;{' '}
                    <Link
                      id='life-insurance-comparison-chart-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/compare-types/'>
                      Check out our comparison chart
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-can-policy-earn-money-faq',
              title: <>Can a life insurance policy <WidowBlock>earn money&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <Typography disableBottomPadding>
                  Yes. With whole life, you could earn dividends<sup>6</sup> that can be taken as cash, used to pay premiums, or buy more coverage. Over time,{' '}
                  <Link
                    id='life-insurance-whole-insurance-can-policy-earn-money-link'
                    variant='primaryDeemphasize'
                    linkUrl='/life-insurance/whole-life-insurance/'
                    ariaLabel='Whole life insurance'>
                    whole
                  </Link>
                  ,{' '}
                  <Link
                    id='life-insurance-universal-life-insurance-can-policy-earn-money-link'
                    variant='primaryDeemphasize'
                    linkUrl='/life-insurance/universal-life-insurance/'
                    ariaLabel='Universal life insurance'>
                    universal
                  </Link>
                  , and{' '}
                  <Link
                    id='life-insurance-vul-insurance-can-policy-earn-money-link'
                    variant='primaryDeemphasize'
                    linkUrl='/life-insurance/variable-universal-life-insurance-vul/'
                    ariaLabel='Variable universal life insurance'>
                    variable universal
                  </Link>
                  {' '}accumulates cash value. You can use this money for anything you need throughout your life.<sup>3</sup>
                </Typography>
              ),
            },
            {
              id: 'life-insurance-how-does-permanent-life-insurance-work-faq',
              title: <>How does permanent life <WidowBlock>insurance work&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography nextElement='typography'>
                    We promise to pay who you name (beneficiaries) a set amount of money when you&#39;re no longer here. You, in return, promise to make regular payments (premiums) to us.{' '}
                  </Typography>
                  <Typography nextElement='typography'>
                    We have three types of{' '}
                    <Link
                      id='life-insurance-permanent-life-insurance-how-it-works-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/permanent-life-insurance/'>
                      permanent life insurance
                    </Link>
                    {' '}to fit your needs:{' '}
                    <Link
                      id='life-insurance-whole-life-insurance-how-it-works-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      ariaLabel='Northwestern Mutual Whole life insurance'>
                      whole
                    </Link>
                    ,{' '}
                    <Link
                      id='life-insurance-universal-life-insurance-how-it-works-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/universal-life-insurance/'
                      ariaLabel='Northwestern Mutual universal life insurance'>
                      universal
                    </Link>
                    , and{' '}
                    <Link
                      id='life-insurance-vul-how-it-works-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/variable-universal-life-insurance-vul/'
                      ariaLabel='Northwestern Mutual variable universal life insurance'>
                      variable universal
                    </Link>
                    . Not only will you have lifelong coverage, as long as you make payments, but you&#39;ll accumulate cash value (tax&#45;deferred). You can use this money anything you wish.<sup>3</sup>
                  </Typography>
                  <Typography disableBottomPadding>
                    And with whole life, you can also earn dividends (while not guaranteed, we&#39;ve paid them every year since 1872) that can be taken as cash, used to pay premiums, or buy more coverage.{' '}
                    <Link
                      id='life-insurance-find-an-advisor-how-it-works-link'
                      variant='primaryDeemphasize'
                      linkUrl='/find-a-financial-advisor/'
                      ariaLabel='Ask a Northwestern Mutual financial advisor about your insurance questions'>
                      Find your advisor
                    </Link>
                    {' '}if permanent life insurance is a good option for you.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-what-is-the-best-life-insurance-work-faq',
              title: <>What is the best life insurance <WidowBlock>to get&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    The best type of life insurance for you depends on your needs and goals. You can get insurance like{' '}
                    <Link
                      id='life-insurance-what-is-the-best-insurance-term-life-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/term-life-insurance/'>
                      term life
                    </Link>
                    {' '}to simply be a safety net to protect your loved ones from the unexpected. Or you can get coverage like{' '}
                    <Link
                      id='life-insurance-what-is-the-best-whole-insurance-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/whole-life-insurance/'>
                      whole life insurance
                    </Link>
                    ,{' '}
                    <Link
                      id='life-insurance-what-is-the-best-life-insurance-universal-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/universal-life-insurance/'>
                      universal life insurance
                    </Link>
                    , or{' '}
                    <Link
                      id='life-insurance-what-is-the-best-insurance-vul-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/variable-universal-life-insurance-vul/'>
                      variable universal life insurance
                    </Link>
                    {' '}that will be a key part of your comprehensive financial plan. Or you could even get a combination of both. Not sure which kind of life insurance is best for you&#63;{' '}
                    <Link
                      id='life-insurance-check-out-comparison-chart-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/compare-types/'>
                      Check out our comparison chart
                    </Link>.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-how-to-get-a-policy-faq',
              title: <>How do I get a life <WidowBlock>insurance policy&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    Your insurance needs are unique, so it&#39;s important to work with your advisor so they can fully understand them. The first step is to{' '}
                    <Link
                      id='life-insurance-get-matched-with-the-right-advisor-link'
                      variant='primaryDeemphasize'
                      linkUrl='/find-a-financial-advisor/'>
                      get matched
                    </Link>
                    {' '}with your advisor. The first thing they&#39;ll do is ask deeper questions to identify the type of coverage &#40;and how much&#41; is right for you. Before issuing a policy, you&#39;ll answer some questions about your health and lifestyle. This will help us determine if you&#39;re qualified and what your premiums will cost.
                  </Typography>
                </>
              ),
            },
            {
              id: 'life-insurance-insurance-riders-offered-faq',
              title: <>What insurance riders does Northwestern <WidowBlock>Mutual offer&#63;</WidowBlock></>,
              contentAs: 'div',
              content: (
                <>
                  <Typography disableBottomPadding>
                    A rider is an optional benefit or feature you can add to your life insurance policy&#8212;usually for an extra cost. No matter if you need{' '}
                    <Link
                      id='life-insurance-whole-life-insurance-available-rider-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/whole-life-insurance/'
                      ariaLabel='Learn about whole life insurance'>
                      whole life
                    </Link>
                    ,{' '}
                    <Link
                      id='life-insurance-universal-life-insurance-available-rider-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/universal-life-insurance/'
                      ariaLabel='Learn about universal life insurance'>
                      universal life
                    </Link>
                    ,{' '}
                    <Link
                      id='life-insurance-vul-insurance-available-rider-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/variable-universal-life-insurance-vul/'
                      ariaLabel='Learn about variable universal life insurance'>
                      variable universal life
                    </Link>
                    , or{' '}
                    <Link
                      id='life-insurance-term-life-insurance-available-rider-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/term-life-insurance/'
                      ariaLabel='Learn about term life insurance'>
                      term life
                    </Link>
                    {' '}insurance, there&#39;s a rider available. Here&#39;s what you can consider:
                  </Typography>
                  <BulletedList
                    bulletType='none'
                    bulletedListData={[
                      { bulletText: <><strong>Waiver of Premium &#8211;</strong> We&#39;ll pay your premiums if you become totally disabled from sickness or accident.</> },
                      { bulletText: <><strong>Additional Purchase Benefit &#8211;</strong> You can buy more coverage at certain ages or when you have certain life events, like getting married or having a child, regardless of changes in your health.</> },
                      { bulletText: <><strong>Accelerated Care Benefit &#8211;</strong> You can use some of your death benefit early to help pay for qualified long&#45;term care expenses, like assisted living or help with doing daily tasks.</> },
                    ]}
                  />
                  <Typography disableBottomPadding>
                    Check out all of our{' '}
                    <Link
                      id='life-insurance-available-service-riders-link'
                      variant='primaryDeemphasize'
                      linkUrl='/life-insurance/life-insurance-riders/'>
                      available insurance riders
                    </Link>
                    . Or{' '}
                    <Link
                      id='life-insurance-fafa-insurance-riders-offer-link'
                      variant='primaryDeemphasize'
                      linkUrl='/find-a-financial-advisor/'>
                      talk with your advisor
                    </Link>
                    {' '}about which rider or riders might best fit your goals.
                  </Typography>
                </>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
